'use client';

import { useEffect, useRef } from 'react';
import { useSearchParams } from 'next/navigation';

/**
 * 알림을 탭해 들어온 페이지에 ?apd={delivery_id} 가 붙어 있으면 열람 시각을 한 번만 기록한다.
 * 실패해도 화면에 영향을 주면 안 되므로 에러는 무시한다(응답도 보지 않는다).
 */
export default function PushOpenBeacon() {
    const searchParams = useSearchParams();
    const apd = searchParams.get('apd');
    const sentRef = useRef(false);

    useEffect(() => {
        if (!apd || sentRef.current) {
            return;
        }
        sentRef.current = true;

        fetch(`${process.env.BASE_URL}/notifications/deliveries/${apd}/opened`, {
            method: 'POST',
            keepalive: true,
        }).catch(() => {});
    }, [apd]);

    return null;
}
